import http from "./http.js";
import httpForm from "./httpForm.js";
import globalConfig from "@/utils/config";

//招标
const ccObj = {
	token: function(options) {
		return http.post(globalConfig.projectURL + "api/Res/token", options);
	},
	status: function(options) {
		return http.post(globalConfig.projectURL + "api/Res/status", options);
	},
	collaboration: function(options) {
		return http.post(globalConfig.projectURL + "api/Res/collaboration", options);
	},
	attachment: function(options) {
		return httpForm.post(globalConfig.projectURL + "api/Res/attachment", options);
	},
	enumItems: function(options) {
		return http.post(globalConfig.projectURL + "api/Res/enumItems", options);
	},
}

const base = {
	NewsQuery: function(options) {
		return http.post(globalConfig.baseURL + "api/Sys/" + "NewsQuery", options);
	},
	LoginSelect: function(options) {
		return http.post(globalConfig.baseURL + "api/Sys/" + "LoginSelect", options);
	}
};
const users = {
	BaseInfo: function(options) { // 登录人信息 
		return http.post(globalConfig.baseURL + "api/Sys/" + "BaseInfo", options);
	},
	UserInfoSelect: function(options) { // 台账
		return http.post(globalConfig.baseURL + "api/Sys/" + "UserInfoSelect", options);
	},
}

//智能警务
const znjw = {
	GateGsgsSelect: function(options) {
		return http.post(globalConfig.projectURL + "api/Cc/GateGsgsSelect", options);
	}
}

const API = {
	base: base,
	znjw,
	users,
	ccObj,
	commonQuery: function(url, options) {
		return new Promise((resolve, reject) => {
			http.post(globalConfig.baseURL + "api/Sys/" + url + "Select", options).then(
				(res) => {
					resolve(res);
				},
				function(error) {
					reject(error);
				}
			);
		});
	},
	saveResource: function(options) {
		// 保存上传一般文件
		(http.defaults.headers.post["Content-Type"] =
			"multipart/form-data;charset=UTF-8"),
		(http.defaults.headers.post["token"] = sessionStorage.getItem("token"));
		return http.post(url + "File/FileUpload", options, {
			transformRequest: [
				function(data, headers) {
					const formData = new FormData();
					for (const key of Object.keys(data)) {
						formData.append(key, data[key]);
					}
					return formData;
				},
			],
		});
	},
	saveResourceNew: function(options) {
		// 保存上传一般文件
		(http.defaults.headers.post["Content-Type"] =
			"multipart/form-data;charset=UTF-8"),
		(http.defaults.headers.post["token"] = sessionStorage.getItem("token"));
		return http.post(url + "File/FileUploadNew", options, {
			transformRequest: [
				function(data, headers) {
					const formData = new FormData();
					for (const key of Object.keys(data)) {
						formData.append(key, data[key]);
					}
					return formData;
				},
			],
		});
	},
	diyCommonHandle: function(apiurl, options) {
		return new Promise((resolve, reject) => {
			http.post(url + apiurl, options).then(
				(res) => {
					resolve(res);
				},
				function(error) {
					reject(error);
				}
			);
		});
	},

};
export default API;